import { EventDetails } from 'sections/Events/components/EventDetails/EventDetails.types';
import { SponsorListItem } from 'sections/Events/GlobalFreightSummit2023/types';

export const eventDetailsData: EventDetails[] = [
  {
    id: 1,
    img: '/images/pages/Events/icon-calendar.svg',
    text: '15 November 2023 — 17 November 2023',
  },
  {
    id: 2,
    img: '/images/pages/Events/icon-location.svg',
    text: 'Coca Cola Arena, Dubai',
  },
  {
    id: 3,
    text: 'Dubai, United Arab Emirates',
    link: 'https://www.google.com/maps/place//@24.9633625,55.1558468,15z?entry=ttu',
  },
];

export const sponsorListData: SponsorListItem[] = [
  {
    id: 1,
    accentText: 'PUT YOUR BRAND IN FRONT OF THOUSANDS',
    text: 'the most influential leaders of the business.',
  },
  {
    id: 2,
    accentText: 'BRAND AWARENESS AND RECOGNITION',
    text: 'logo and company information placement.',
  },
  {
    id: 3,
    accentText: 'GENERATE NEW SALES AND PARTNERSHIPS',
    text: 'with registrants, vendors and speakers.',
  },
  {
    id: 4,
    accentText: 'STRENGTHEN YOUR BRAND POSITION',
    text: 'within the industry of freight management and logistics.',
  },
  {
    id: 5,
    accentText: 'ESTABLISH',
    text: 'connect with international strategic partners.',
  },
  {
    id: 6,
    accentText: 'PROMOTION',
    text: 'your products, services and research to international buyers.',
  },
  {
    id: 7,
    accentText: 'NETWORK',
    text: 'with like-minded industry members.',
  },
  {
    id: 8,
    accentText: 'ENHANCE CREDIBILITY',
    text: 'highlight your company’s expertise to a focused audience.',
  },
  {
    id: 9,
    accentText: 'ENGAGE WITH YOUR AUDIENCE',
    text: 'with multiple engagement formats.',
  },
  {
    id: 10,
    accentText: 'ACCESS TO KNOWLEDGE',
    text: 'share a stage with thought leaders.',
  },
];